import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FormItem from '../../components/form/FormItem'
import { MdTitle } from 'react-icons/md'
import { BiX } from 'react-icons/bi'
import { Button, Form } from 'reactstrap'
import { fetchSocialMediaCreate } from '../../redux/slices/socialMediaCreateSlice'
import { fetchSocialMediaUpdate } from '../../redux/slices/socialMediaUpdateSlice'
import { fetchSocialMediaGet } from '../../redux/slices/socialMediaGetSlice'
import DragDropFiles from '../../components/form/DragDropFiles'

const CrudSocialMedia = ({ showMenu, setShowMenu, setChanged, setSelectedItem, selectedItem, t }) => {
    const [formData, setFormData] = useState({ files: [] })
    const dispatch = useDispatch()

    const getData = async () => {
        if (selectedItem !== 0) {
            var data = await dispatch(fetchSocialMediaGet({ id: selectedItem }))
            if (data.payload) {
                setFormData({
                    files: data.payload?.files,
                    titletr: data.payload?.title["tr"],
                    titleen: data.payload?.title["en"],
                    slugtr: data.payload?.slug["tr"],
                    slugen: data.payload?.slug["en"],
                })
            }
        }
    }

    const closeModal = () => {
        setFormData({ files: [], titletr: "", titleen: "", slugtr: "", slugen: "" })
        setShowMenu(!showMenu)
        setSelectedItem(0)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const title = { "tr": formData.titletr, "en": formData.titleen }
        const slug = { "tr": formData.slugtr, "en": formData.slugtr }

        const newFiles = formData.files.filter(file => file.file);

        await dispatch(
            selectedItem === 0 ?
                fetchSocialMediaCreate({ file: newFiles, title: title, slug: slug }) :
                fetchSocialMediaUpdate({ id: selectedItem, file: newFiles, title: title, slug: slug })
        )
        setFormData({ files: [], titletr: "", titleen: "", slugtr: "", slugen: "" })
        setFormData({ files: [] })
        closeModal()
        setChanged(true)
        getData()
        setShowMenu(false)
    }

    useEffect(() => { getData() }, [dispatch, selectedItem])

    return (
        <div className={showMenu ? 'right-popup' : 'd-none'}>
            <div className='right-popup-close' onClick={closeModal}><BiX size={24} /></div>
            <div className='right-popup-menu'>
                <div className='mb-3 text-center'><h5>{t(selectedItem === 0 ? "add_social_media" : "edit_social_media")}</h5></div>
                <Form onSubmit={handleSubmit}>
                    <DragDropFiles
                        formData={formData}
                        setFormData={setFormData}
                        name='files'
                        selectedItem={selectedItem}
                        title={t("images")}
                    />
                    <FormItem
                        id={`titletr`}
                        name={`titletr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titletr'
                    />
                    <FormItem
                        id={`titleen`}
                        name={`titleen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titleen'
                    />
                    <FormItem
                        id={`slugtr`}
                        name={`slugtr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("slug")}`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='slugtr'
                    />

                    <div className='d-flex justify-content-end mt-4 w-100'>
                        <Button type='submit' color={selectedItem === 0 ? 'primary' : 'warning'} className="text-white">
                            {t(selectedItem === 0 ? "add" : "edit")}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CrudSocialMedia